import classes from './ChatWidget.module.scss'

// Işıltı yıldızları: konum FAB kutusunun (56x56) sol üst köşesine göre px; hepsi logonun dışında kalır.
const SPARKLES = [
  { left: -20, top: -4, size: 10, delay: 0 },
  { left: 65, top: -14, size: 7, delay: 0.7 },
  { left: 70, top: 44, size: 8, delay: 1.4 },
  { left: -8, top: 66, size: 6, delay: 2 },
  { left: 26, top: -24, size: 6, delay: 2.4 },
]

/**
 * FAB'in arkasındaki ışıltı: hale + ters yönde dönen iki ışın katmanı + ışıltı yıldızları.
 * Yalnız süs — ekran okuyucudan gizli, tıklamayı FAB'e bırakır. Görünüm ve ince ayar
 * değişkenleri `ChatWidget.module.scss` içindeki `.fabGlow` bloğundadır.
 */
export default function FabGlow() {
  return (
    <span className={classes.fabGlow} aria-hidden='true'>
      <span className={`${classes.fabRays} ${classes.fabRaysPrimary}`} />
      <span className={`${classes.fabRays} ${classes.fabRaysSoft}`} />
      <span className={classes.fabHalo} />
      {SPARKLES.map((s, i) => (
        <span
          key={i}
          className={classes.fabSparkle}
          style={{ left: s.left, top: s.top, width: s.size, height: s.size, animationDelay: `${s.delay}s` }}
        />
      ))}
    </span>
  )
}
